var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasicInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 70,
    viewBox: "0 0 116 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 70,
    rx: 7,
    fill: "#FEF9EF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6708_10613",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 116,
    height: 70
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 70,
    rx: 7,
    fill: "#FEF9EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6708_10613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6708_10613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2002 47.6052L84.2002 22.3949L-121 22.3948L-121 47.6052L84.2002 47.6052Z",
    fill: "#B8DEE3",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2002 22.3902L84.2002 -2.82022L-121 -2.82023L-121 22.3902L84.2002 22.3902Z",
    fill: "#FEBD02",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2002 72.8156L84.2002 47.6052L-121 47.6052L-121 72.8156L84.2002 72.8156Z",
    fill: "#E9725B",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6016 41.0919C97.6774 43.2676 101.932 42.5348 104.105 39.4551C106.279 36.3754 105.547 32.1151 102.471 29.9394C99.3949 27.7637 95.1398 28.4966 92.9668 31.5762C90.7938 34.6559 91.5257 38.9162 94.6016 41.0919Z",
    fill: "#FEF9EF",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6016 64.0919C97.6774 66.2676 101.932 65.5348 104.105 62.4551C106.279 59.3754 105.547 55.1151 102.471 52.9394C99.3949 50.7637 95.1398 51.4966 92.9668 54.5762C90.7938 57.6559 91.5257 61.9162 94.6016 64.0919Z",
    fill: "#FEF9EF",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6016 18.0919C97.6774 20.2676 101.932 19.5348 104.105 16.4551C106.279 13.3754 105.547 9.11513 102.471 6.93944C99.3949 4.76375 95.1398 5.49657 92.9668 8.57624C90.7938 11.6559 91.5257 15.9162 94.6016 18.0919Z",
    fill: "#FEF9EF",
    stroke: "#363636",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6708_10613)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6708_10613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3077 35.7941L106.939 26L109 28.1104L97.3077 40L90 32.569L92.0608 30.4735L97.3077 35.7941Z",
    fill: "#94CED7"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6708_10613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3077 58.7941L106.939 49L109 51.1104L97.3077 63L90 55.569L92.0608 53.4735L97.3077 58.7941Z",
    fill: "#E9725B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6708_10613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3077 12.7941L106.939 3L109 5.1104L97.3077 17L90 9.569L92.0608 7.47346L97.3077 12.7941Z",
    fill: "#FEBD02"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6708_10613",
    x: 89,
    y: 25,
    width: 23,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6708_10613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6708_10613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6708_10613",
    x: 89,
    y: 48,
    width: 23,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6708_10613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6708_10613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6708_10613",
    x: 89,
    y: 2,
    width: 23,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6708_10613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6708_10613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6708_10613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.4368,
    height: 206,
    fill: "white",
    transform: "translate(160.218 -3.21838) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6708_10613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(87 25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicInfo);
export default __webpack_public_path__ + "static/media/BasicInfo.0782376570377d67431003da43c1e1ca.svg";
export { ForwardRef as ReactComponent };